<abp-modal [(visible)]="openMoveModal" (disappear)="modalClose.emit(false)">
  <ng-template #abpHeader>
    <h3>
      {{ 'RegisterService::MoveAssets' | abpLocalization }}
    </h3>
  </ng-template>
  <ng-template #abpBody>
    <div class="mb-3">
      <app-locations-with-search
        [readonly]="true"
        [selectedNode]="selectedLocation"
        (selectedNodeChange)="selectLocation($event)"
        [locationDefinition]="locationDefinition"
        [displayHeaders]="false"
        [withLookup]="true"
        [showTransferNotes]="!hasTransfer"
        [showSubAssetsNotes]="hasTransfer"
        [(subAssetsNotes)]="transferData.notes"
        [(transferNotes)]="notes"
      />
    </div>
    <div class="flex gap-2" *ngIf="showMessage">
      <label class="text-black-base font-medium">
        {{ 'ServicingService::TotalSelected' | abpLocalization }}:
      </label>
      <label class="form-label"> {{ assetIds.length }} </label>
    </div>

    <ng-container *ngIf="showRecheckPanel && selectedAssets.length > 1">
      <hr class="my-3" />
      <div>
        <table class="table-scroll-wrapper">
          <thead>
            <tr>
              <th class="min-w-[50px]">
                {{ 'RegisterService::Id1SlashId2' | abpLocalization }}
              </th>
              <th class="min-w-[50px]">
                {{ 'RegisterService::Barcode' | abpLocalization }}
              </th>
              <th class="min-w-[50px]">
                {{ 'RegisterService::Nickname' | abpLocalization }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of eligibleAssetDetails">
              <td>
                {{ (item.primaryIdPrefix ?? '') + item.primaryID }}/{{ item.secondaryID || '-' }}
              </td>
              <td>{{ item.barcode }}</td>
              <td>{{ item.categoryNickname }}</td>
            </tr>
          </tbody>
        </table>
        <div class="flex items-center gap-1 my-3">
          <input type="checkbox" id="applyRecheck" [(ngModel)]="applyRecheck" />
          <label for="applyRecheck">{{ 'RegisterService::ApplyRecheck' | abpLocalization }}</label>
        </div>
      </div>
    </ng-container>
  </ng-template>
  <ng-template #abpFooter>
    <button type="button" class="btn btn-primary" (click)="move()" [disabled]="isBusy">
      {{ 'AbpUi::Apply' | abpLocalization }}
    </button>
    <button type="button" class="btn btn-secondary" abpClose>
      {{ 'AbpUi::Close' | abpLocalization }}
    </button>
  </ng-template>
</abp-modal>
